Ext.define('SA.view.AliasWindow2', {
    alias: 'widget.location-alias-window-2',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-location-alias-window',
    includeCancelBtn: true,

    getBodyItems() {
        return [
            {
                xtype: 'component',
                cls: 'sa-location-alias-window-field-label',
                html: 'Alias:'
            }, {
                xtype: 'sa-textfield',
                itemId: 'field',
                cls: 'sa-location-alias-window-field-input',
                height: 35
            }
        ];
    },

    getFooterItems() {
        return {
            xtype: 'sa-button',
            itemId: 'saveBtn',
            text: 'Save',
            ui: 'primary'
        };
    },

    getTitle() {
        return this.titleHtml;
    }
});